__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/18970cf/_next/";